/*
 Example usage:

 var sizeClassConfigFn = classifyElementSizeFactory({
 'phone':          {  main:true,  minWidth:    0,  maxWidth:  450  },
 'phone-phablet':  {              minWidth:    0,  maxWidth:  660  },
 'phone-tablet':   {              minWidth:    0,  maxWidth:  890  },
 'phablet':        {  main:true,  minWidth:  450,  maxWidth:  660  },
 'phablet-tablet': {              minWidth:  450,  maxWidth:  890  },
 'phablet-up':     {              minWidth:  450  },
 'tablet':         {  main:true,  minWidth:  660,  maxWidth:  890  },
 'tablet-netbook': {              minWidth:  660,  maxWidth: 1100  },
 'tablet-up':      {              minWidth:  660  },
 'netbook':        {  main:true,  minWidth:  890,  maxWidth: 1100  },
 'netbook-up':     {              minWidth:  890  },
 'wide':           {  main:true,  minWidth: 1100  },
 }), {
 // bemName: 'mycomponent', // Defaults to element's first className - falling back to 'element' as a last resort.
 // bemModifier: 'size', // Default: 'format'
 });

 // Mithril use:
 m('div.foobar.foobar--cool', { config: sizeClassConfigFn }, 'Widget content');

 // Standalone use:
 var elm = document.querySelector('div.foobar.foobar--cool');
 window.addEventListener('resize', function(){
 var state = sizeClassConfigFn.check(elm);
 if ( state.changed ) {
 console.log( 'New main format:', state.is );
 console.log( 'Active formats:', state.active );
 }
 });

 */
var _getFormatInfo = function (formats, classPrefix, width) {
    var classNames = '';
    var active = {};
    var mainFormat = '';
    for (var formatName in formats) {
        var fmt = formats[formatName];
        if ((!fmt.minWidth || fmt.minWidth <= width) && (!fmt.maxWidth || width < fmt.maxWidth)) {
            classNames += classPrefix + formatName;
            active[formatName] = true;
            if (fmt.main) {
                mainFormat = formatName;
            }
        }
    }
    return {
        classNames: classNames,
        active: active,
        is: mainFormat,
    };
};

var _getNearestBreakpoints = function (breakpoints, width) {
    var bp;
    var i = breakpoints.length - 1;
    while ((bp = breakpoints[i]) && bp > width) {
        i--;
    }
    return [breakpoints[i], breakpoints[i + 1]];
};

var _listBreakpoints = function (formats) {
    var breakpoints = {0: 1, 9999999: 1}; // start with universal extremes
    for (var key in formats) {
        var bp = formats[key];
        breakpoints[bp.minWidth || 0] = 1;
        breakpoints[bp.maxWidth || 0] = 1;
    }
    return Object.keys(breakpoints)
        .map(function (width) {
            return parseInt(width, 10);
        })
        .sort(function (a, b) {
            return a - b;
        });
};

var _initMonitor = function (elm, formats, opts) {
    var monitor = {};
    monitor.classPrefix =
        ' ' + (opts.bemName || elm.className.trim().split(' ')[0] || 'element') +
        '--' + (opts.bemModifier || 'format') + '--';
    monitor.classRe = new RegExp(monitor.classPrefix + '\\S+', 'g');
    monitor.formats = formats;
    monitor.breakpoints = _listBreakpoints(formats);
    return monitor;
};


var _updateMonitor = function (elm, monitor) {
    var width = elm.offsetWidth;
    var nearestBreakpoints = monitor.nearestBreakpoints;
    var needsUpdate = monitor.lastClassName !== elm.className;
    monitor.lastState = monitor.state || {};
    if (width !== monitor.lastWidth &&
        ( !nearestBreakpoints || width < nearestBreakpoints[0] || width >= nearestBreakpoints[1] )
    ) {
        needsUpdate = true;
        monitor.nearestBreakpoints = _getNearestBreakpoints(monitor.breakpoints, width);
        var format = _getFormatInfo(monitor.formats, monitor.classPrefix, width);
        monitor.formatClasses = format.classNames;
        monitor.state = {
            active: format.active,
            is: format.is,
        };
    }
    monitor.lastWidth = width;
    return needsUpdate;
};


var classifyElementSizeFactory = function (formats, opts) {
    // Mithril compatible config function
    var configFn = function (elm, init, ctx) {
        var monitor = ctx.monitor;
        if (!ctx.monitor) {
            monitor = (elm.ctx || {}).monitor || _initMonitor(elm, formats, opts || {});
            ctx.monitor = monitor;
        }
        elm.ctx = ctx; // Expose mithril ctx for use with `check()`

        var needsUpdate = _updateMonitor(elm, monitor);
        if (needsUpdate) {
            elm.className = elm.className.replace(monitor.classRe, '') + monitor.formatClasses;
            monitor.lastClassName = elm.className;
        }
    };
    // Standalone check function that emulates Mithril update/redraw call
    configFn.check = function (elm) {
        var init = true;
        var ctx = elm.ctx || {};
        if (!elm.ctx) {
            init = false;
            ctx = elm.ctx = {};
        }
        configFn(elm, init, ctx);
        var state = ctx.monitor.state;
        return {
            active: state.active,
            is: state.is,
            // wasActive: monitor.lastState.active,
            // was: monitor.lastState.is,
            changed: state !== ctx.monitor.lastState,
        };
    };

    return configFn;
};


module.exports = classifyElementSizeFactory;
